import {getDataWithPromise, getParamList, Globals, handleAjaxError, preProcessForm} from "./BaseDataFns";

export const getSchool = ( school_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/' + school_id + '?include-attendance-officer&include-teachers&include-pupils&include-attendance-officers&include-groups';

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getChildSchools = ( child_id, flagArray, onComplete ) =>
{
    const paramList = getParamList( flagArray, '?') ;

    const url = Globals.APIFolder + '/children/' + child_id + '/schools' + paramList ;

    getDataWithPromise ( url, 'GET', {} )
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}

export const updateChildSchool = ( child_id, childDetails, schoolDetails, onComplete ) =>
{
    const data = {
        child_details: childDetails,
        setting_details: schoolDetails,
    };

    const url = Globals.APIFolder + '/children/' + childDetails.child_id + '/schools';

    getDataWithPromise ( url, 'PUT', data )
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}

export const getSchoolAttendanceOfficers = ( school_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/' + school_id + '/attendanceofficers';

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getSchoolTeachers = ( school_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/' + school_id + '/desiteachers';

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getSchoolgroups = ( authority_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schoolgroups?authorityid=' + authority_id ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getSchoolsInGroup = ( school_group_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schoolgroups/' + school_group_id + '/schools' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateSchoolDetails = ( school_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/' + school_id ;

    getDataWithPromise ( url, 'PUT', {data} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const createSchool = ( data, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools' ;

    getDataWithPromise ( url, 'POST', {data} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getPlannedSchoolMoveDetails = ( planned_school_move_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/moves/' + planned_school_move_id ;

    getDataWithPromise ( url, 'GET'  )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getPlannedSchoolMoves = (onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/moves' ;

    return getDataWithPromise ( url, 'GET', {} ) ;
}

export const getPlannedSchoolMoveForChild = (child_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/moves/child/' + child_id ;

    return getDataWithPromise ( url, 'GET', {} ) ;
}

export const createPlannedSchoolMove = ( child_id, data, onComplete ) =>
{
    // We have dates in there, so convert to dd/mm/yyyy format
    preProcessForm ( data ) ;

    const url = Globals.APIFolder + '/schools/moves/' + child_id ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updatePlannedSchoolMove = ( planned_school_move_id, data, onComplete ) =>
{
    // We have dates in there, so convert to dd/mm/yyyy format
    preProcessForm ( data ) ;

    const url = Globals.APIFolder + '/schools/moves/' + planned_school_move_id ;

    getDataWithPromise ( url, 'PUT', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const deletePlannedSchoolMove = ( planned_school_move_id, onComplete ) =>
{
    // We have dates in there, so convert to dd/mm/yyyy format
    const url = Globals.APIFolder + '/schools/moves/' + planned_school_move_id ;

    getDataWithPromise ( url, 'DELETE' )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getChildSchoolPlacementDetails = ( placement_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/childschoolplacements/' + placement_id ;

    getDataWithPromise ( url, 'GET'  )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const deleteChildSchoolPlacement = ( placement_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/childschoolplacements/' + placement_id ;

    getDataWithPromise ( url, 'DELETE'  )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateChildSchoolPlacementDates = ( placement_id, data, onComplete ) =>
{
    // We have dates in there, so convert to dd/mm/yyyy format
    preProcessForm ( data ) ;

    const url = Globals.APIFolder + '/childschoolplacements/' + placement_id ;

    getDataWithPromise ( url, 'PUT', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}